import { render, staticRenderFns } from "./Articledetail.vue?vue&type=template&id=ee9a5a8a&scoped=true&"
import script from "./Articledetail.vue?vue&type=script&lang=js&"
export * from "./Articledetail.vue?vue&type=script&lang=js&"
import style0 from "./Articledetail.vue?vue&type=style&index=0&id=ee9a5a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9a5a8a",
  null
  
)

export default component.exports